import { SolarCalculatorConsumption } from './solar-calculator-consumption';
import { RecalculateData } from '../../components/solar-calculation-result/model/recalculate-data';
import { SiteDataInputType } from '../../components/calculator/calculator.component';

export interface SolarCalculatorRequest {
  consumption?: SolarCalculatorConsumption[];
  productionsHourly?: ProductionData[];
  consumptionHourly?: ConsumptionData[];
  consumptionAverageBill?: number;
  googleLatLng?: {
    lat: string;
    lng: string;
  };
  area?: number;
  tilt?: string;
  azimuth?: string;
  systemCapacity?: number;
  priceID: string;
  reCalculation?: RecalculateData;
  siteDataInputType?: SiteDataInputType;
  address?: string;
  projectName?: string;
  investorName?: string;
  typeCalculation?: ETypeCalculation;
  userContact?: string;
  source?: string;
}


export class ConsumptionData {
  date: string;
  year: string;
  consumption: string;
  peakPower?: string;
}


export interface ProductionData {
  production: string;
  peakPower?: string[] | null;
}

export enum ETypeCalculation {
  NO_FEED_IN_ENERGY = 'NO_FEED_IN_ENERGY',
  HR_FEED_IN_NET = 'HR_FEED_IN_NET',
  HR_FEED_IN_CALC = 'HR_FEED_IN_CALC',
  BA_FE_FEED_IN_NET = 'BA_FE_FEED_IN_NET',
  BA_RS_FEED_IN_NET = 'BA_RS_FEED_IN_NET',
  BA_FE_FEED_IN_CALC = 'BA_FE_FEED_IN_CALC',
  BA_RS_FEED_IN_CALC = 'BA_RS_FEED_IN_CALC',
}
